import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';


register('wm-layoutgrid', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {

          return `<${tagName} wmLayoutGrid wmsTransclude ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
